import { Card } from "@clipboard-health/ui-components";
import { CardContent, Skeleton, Stack, useTheme } from "@mui/material";

export function ShiftHistoryCardSkeleton() {
  const theme = useTheme();

  return (
    <Card
      outlined
      sx={{ flexGrow: 1 }}
      role="progressbar"
      aria-label="Loading shift history"
      variant="tertiary"
    >
      <CardContent sx={{ padding: theme.spacing(6) }}>
        <Stack spacing={6} direction="column">
          <Stack direction="row" spacing={4} alignItems="flex-start">
            <Skeleton variant="rounded" width={48} height={48} />
            <Stack spacing={1} sx={{ flexGrow: 1 }}>
              <Skeleton variant="text" width="40%" height="1.25rem" />
              <Skeleton variant="text" width="60%" height="1.25rem" />
              <Skeleton variant="text" width="40%" height="1.25rem" />
              <Skeleton variant="text" width="75%" height="1.25rem" />
            </Stack>
          </Stack>

          <Stack spacing={2}>
            <Skeleton variant="text" width="90%" height="1.5rem" />
            <Skeleton variant="text" width="80%" height="1.5rem" />
            <Skeleton variant="text" width="70%" height="1.5rem" />
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

export function ShiftHistoryLoadingPageState() {
  return (
    <Stack spacing={6}>
      {Array.from({ length: 5 }, (_, index) => (
        <ShiftHistoryCardSkeleton key={index} />
      ))}
    </Stack>
  );
}
